import { useTranslation } from "react-i18next";

import { useTheme } from "@/theme/ThemeProvider";

/** Icon button that toggles light/dark. */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={t("actions.toggleTheme")}
      aria-pressed={isDark}
      title={isDark ? t("actions.dark") : t("actions.light")}
      className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-border text-fg-muted hover:bg-bg-subtle hover:text-fg"
    >
      {/* Sun / moon glyphs — decorative, label lives on the button. */}
      <span aria-hidden="true" className="text-base">
        {isDark ? "☾" : "☀"}
      </span>
    </button>
  );
}
